import { TASK_TYPES } from '../../../ContentLists/TaskList/constants'
import type { GetTimelineProps } from '../../../monthly-sheet-details/types'
import type { TimelineItemValues } from '../../types'
import { mayAddPendingElement, mayAddClosedElement, mayAddSharedDataAction, mayAddDefaultClosedAction } from '../utils'
import { getAbsenceRequestItem, getDocumentItem, getFormItem } from './default-timeline-items'

export const createDefaultTimeline = (props: GetTimelineProps): TimelineItemValues[] => {
  const { task } = props
  const { taskType } = task

  switch (taskType) {
    case TASK_TYPES.monthlySheet:
      return [
        getDocumentItem(props),
        ...mayAddPendingElement(props),
        ...mayAddDefaultClosedAction(props),
        ...mayAddClosedElement(props),
      ] as TimelineItemValues[]

    case TASK_TYPES.shareUserData:
      return [
        getFormItem(props),
        ...mayAddSharedDataAction(props),
        ...mayAddDefaultClosedAction(props),
        ...mayAddClosedElement(props),
      ] as TimelineItemValues[]

    case TASK_TYPES.absenceRequest:
      return [
        getAbsenceRequestItem(props),
        ...mayAddDefaultClosedAction(props),
        ...mayAddClosedElement(props),
      ] as TimelineItemValues[]

    default:
      return []
  }
}
